import { pushTo } from '@app/core/routing';
import { useFragmentQuery } from '@app/modules/fragments/hooks/useFragment';
import { routeGenerator } from '@app/modules/fragments/routing/FragmentsRoutes';
import { VideoEditionPublishMenu } from '@app/modules/social-export/publish';

export interface FragmentVideoEditionPublishMenuProps {
  /** Video editor edit id passed to the upload route for source preselection (`editId` query param). */
  editId: string;
  fragmentId: string;
  /**
   * When true, only a share icon opens the menu (used next to the “published on …” label on edit cards).
   */
  iconOnly?: boolean;
}

/**
 * "Publicar en" dropdown for a generated edit: lists platforms available for a new publish
 * (same rules as the publish tab) and navigates to the upload screen with this edit preselected.
 */
export function FragmentVideoEditionPublishMenu({
  editId,
  fragmentId,
  iconOnly = false,
}: FragmentVideoEditionPublishMenuProps) {
  const fragmentQuery = useFragmentQuery(fragmentId);
  const fragment = fragmentQuery.data;

  if (!fragment) {
    return null;
  }

  return (
    <VideoEditionPublishMenu
      stationId={fragment.stationId}
      iconOnly={iconOnly}
      onSelectPlatform={(platformId) => {
        pushTo(routeGenerator.upload(fragment, { id: platformId }, editId));
      }}
    />
  );
}
